import { render, staticRenderFns } from "./OpenPerformanceEvaluationPage.vue?vue&type=template&id=6a10002c"
import script from "./OpenPerformanceEvaluationPage.vue?vue&type=script&lang=js"
export * from "./OpenPerformanceEvaluationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports